module.exports = __webpack_public_path__ + "img/ic_12_next.9ea68c86.svg";